module.exports = __webpack_public_path__ + "static/media/flags_BRA.2b4014bf.svg";